import {
  WATCHHISTORY_LOAD,
  WATCHHISTORY_LOAD_SUCCESS,
  HISTORY_ACTION_SUCCESS,
  HISTORY_DELETE_ALL,
  HISTORY_DELETE
} from "./actions";
import {
  DETAILS_LOAD_SUCCESS,
  LOAD_OTHER_SUCCESS
} from "../../redux-root/actions";

const initialState = {
  channelData: null,
  movieData: null,
  showData: null,
  loaded: false
};

export function watchHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case WATCHHISTORY_LOAD:
    case HISTORY_DELETE_ALL:
    case HISTORY_DELETE:
      return {
        ...state,
        loaded: false,
        refreshedLoad: false
      };

    case WATCHHISTORY_LOAD_SUCCESS:
      return {
        ...state,
        channelData: action.channel,
        movieData: action.movie,
        showData: action.show,
        loaded: true,
        refreshedLoad: false
      };

    case DETAILS_LOAD_SUCCESS:
      if (action.history.movie) {
        return {
          ...state,
          movieData: action.history.movie,
          refreshedLoad: false
        };
      } else if (action.history.channel) {
        return {
          ...state,
          channelData: action.history.channel,
          refreshedLoad: false
        }
      }

      return {
        ...state,
        showData: action.history.show,
        refreshedLoad: false
      };

    case HISTORY_ACTION_SUCCESS:
      let newMovieData = state.movieData;
      let newChannelData = state.channelData;
      let newShowData = state.showData;

      if (action.history.movie) {
        newMovieData = action.history.movie;
      }

      if (action.history.channel) {
        newChannelData = action.history.channel;
      }

      if (action.history.show) {
        newShowData = action.history.show;
      }

      return {
        ...state,
        movieData: newMovieData,
        channelData: newChannelData,
        showData: newShowData,
        loaded: true
      };

    case LOAD_OTHER_SUCCESS:
      return {
        ...state,
        channelData: action.channel
      }

    default:
      return state;
  }
}
